import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Pagination } from '@mui/material';
import ShowLoading from "../../components/ShowLoading";
import ShowError from "../../components/ShowError";
import { ThemeProvider } from '@mui/material';
import muiTheme from "../../components/muiTheme";
import { getTotalUserPages, getUsersByPage, searchUsers } from "../helpers/adminapis";
import UserCard from "./UserCard";

function UsersList(_props) {

    const admin = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState();

    const setTotalUserPages = () => {
        getTotalUserPages(admin._id, admin.token)
            .then(data => {
                if (data?.error) {
                    setError(data.error);
                } else {
                    setTotalPages(data.totalPages);
                }
                setIsLoading(false)
            })
            .catch(err => console.log(err) && isLoading(false))
    }

    const setUsersData = (page) => {
        getUsersByPage(admin._id, { page, pageSize }, admin.token)
            .then(data => {
                if (data?.error) {
                    setError(data.error);
                } else if (data) {
                    setUsers(data);
                }
                setIsLoading(false)
            })
            .catch(err => console.log(err) && isLoading(false))
    }

    useEffect(() => {
        setTotalUserPages();
        setUsersData(pageNumber);
    }, []);

    const handlePageChange = (event, page) => {
        event.preventDefault();
        setIsLoading(true);
        setUsersData(page);
        setPageNumber(page);
    }

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    }

    const handleSearchUser = (event) => {
        event.preventDefault();
        searchUsers(admin._id, search, admin.token)
            .then(data => {
                if (data?.error) {
                    setError(data.error);
                } else if (data) {
                    setUsers(data);
                }
                setIsLoading(false)
            })
            .catch(err => console.log(err) && isLoading(false))
    }

    return (
        <div>
            <ShowError error={error} />
            <ShowLoading isLoading={isLoading} />
            <>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Search user by email" value={search} onChange={handleSearchChange} />
                    <button class="btn btn-dark" type="button" onClick={handleSearchUser} >Search</button>
                </div>

                {users && users?.map((userData) => <UserCard key={userData._id} user={userData} />)}
                {users?.length < 1 && <>
                    <div className="card fw-bold text-center p-5 shadow-lg">
                        <div className=" m-auto mb-5">
                            <lord-icon
                                src="https://cdn.lordicon.com/ncxoarcp.json"
                                trigger="loop"
                                delay="1000"
                                colors="primary:#892cdc"
                                style={{ width: "250px", height: "250px" }}>
                            </lord-icon>
                        </div>
                        <h3>There are no users yet!</h3>
                        <h3 className="mt-5">Start marketing to get some users!</h3>
                    </div>
                </>}
                {totalPages > 1 && <ThemeProvider theme={muiTheme}><div className="mt-4"><Pagination count={totalPages} color="purple" size="large" onChange={handlePageChange} page={pageNumber} /></div></ThemeProvider>}
            </>
        </div>
    );
}

export default UsersList;